module.exports = __webpack_public_path__ + "static/media/191ec203.1188bdf5.jpg";